import ExcelJS from "exceljs"; 
import { saveAs } from "file-saver";
import dayjs from "dayjs";

const generateGroupDepositAuditExcel = async (data) => {
  try {
    if (!data || !Array.isArray(data)) {
      throw new Error("Invalid data format");
    }

    const branchMap = {};
    data.forEach((item) => {
      if (!branchMap[item.branchName]) {
        branchMap[item.branchName] = [];
      }
      branchMap[item.branchName].push(item);
    });

    const categories = ["1-2", "3-4", "5-6", "7-8", "9-10", "Over 10"];

    const workbook = new ExcelJS.Workbook();
    workbook.creator = "Audit System";
    workbook.created = new Date();

    const sheet = workbook.addWorksheet("Group Deposit Audit", {
      pageSetup: { paperSize: 9, orientation: "landscape" },
    });

    sheet.mergeCells("A1:H1");
    const titleCell = sheet.getCell("A1");
    titleCell.value = "Group Deposit Audit Report";
    titleCell.font = { size: 16, bold: true };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    sheet.getRow(1).height = 30;

    let startCol = 1;

    Object.keys(branchMap).forEach((branchName) => {
      const branchData = branchMap[branchName];

      sheet.mergeCells(2, startCol, 2, startCol + 3);
      const branchCell = sheet.getCell(2, startCol);
      branchCell.value = branchName;
      branchCell.font = { size: 14, bold: true };
      branchCell.alignment = { horizontal: "center", vertical: "middle" };
      sheet.getRow(2).height = 25;

      const headers = [
        "Number of team members",
        "Number of teams (as of audit date)",
        "Number of team members 30 days before audit date",
        "Number of team members on audit date",
      ];

      headers.forEach((header, index) => {
        const cell = sheet.getCell(3, startCol + index);
        cell.value = header;
        cell.font = { bold: true, size: 11 };
        cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      sheet.getRow(3).height = 40;

      const categoryMap = {
        "1-2": [],
        "3-4": [],
        "5-6": [],
        "7-8": [],
        "9-10": [],
        "Over 10": [],
      };

      branchData.forEach((item) => {
        const count = item.memberCount;
        if (count >= 1 && count <= 2) categoryMap["1-2"].push(item);
        else if (count >= 3 && count <= 4) categoryMap["3-4"].push(item);
        else if (count >= 5 && count <= 6) categoryMap["5-6"].push(item);
        else if (count >= 7 && count <= 8) categoryMap["7-8"].push(item);
        else if (count >= 9 && count <= 10) categoryMap["9-10"].push(item);
        else if (count > 10) categoryMap["Over 10"].push(item);
      });

      categories.forEach((cat, idx) => {
        const row = sheet.getRow(4 + idx);
        row.getCell(startCol).value = cat;
        row.getCell(startCol + 1).value = categoryMap[cat].length;
        row.getCell(startCol + 2).value = "";
        row.getCell(startCol + 3).value = "";

        for (let c = startCol; c <= startCol + 3; c++) {
          const cell = row.getCell(c);
          cell.alignment = { horizontal: "center", vertical: "middle" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
      });

      for (let i = 0; i < 4; i++) {
        sheet.getColumn(startCol + i).width = i === 0 ? 25 : 35;
      }

      startCol += 5;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const fileName = `Group_Deposit_Audit_Report_${dayjs().format("YYYY-MM-DD_HHmmss")}.xlsx`;
    saveAs(blob, fileName);

    return true;
  } catch (error) {
    console.error("Error generating Excel file:", error);
    throw error;
  }
};

export default generateGroupDepositAuditExcel;
